import React from 'react';
import { useTranslation } from 'react-i18next';

import type { LiveShopping } from '../../@types/LiveShopping';
import useDateIsBelow from '../../hooks/useDateIsBelow';
import { IconPlay } from '../../styled-components/components/Icon';
import RenderClientSide from '../render/render-client-side';

const limit = 24 * 60 * 60 * 1000;

interface PlayButtonProps {
  liveShopping: LiveShopping;
  title?: string;
  register: (e: HTMLButtonElement, showId: string) => void;
}

const PlayButton = ({ liveShopping, title, register }: PlayButtonProps) => {
  const { t } = useTranslation(['liveshopping']);
  const currentDate = new Date().setMilliseconds(0).valueOf();
  const isBelow24h = useDateIsBelow(new Date(liveShopping.scheduledStartAt), limit);

  const isLive =
    liveShopping.isLive ||
    (!liveShopping.isArchived &&
      new Date(liveShopping.scheduledStartAt).setMilliseconds(0).valueOf() <= currentDate);

  if (!isBelow24h && !isLive) return null;

  return (
    <RenderClientSide>
      <button
        type="button"
        data-wx-actionbutton="action huge"
        id={liveShopping.showId}
        ref={(e: HTMLButtonElement) => register(e, liveShopping.showId)}
        title={title ? title : t('openLiveShopppingEvent', { ns: 'liveshopping' })}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <IconPlay />
      </button>
    </RenderClientSide>
  );
};

export default PlayButton;
